import { ActionContext } from 'vuex'
import apiAdminMapLayer from '@/api/admin/mapLayer'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IMapLayerState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer';
import { AloError } from '@/models/alo/AloError';
import { AloBaseArray } from '@/models/alo/AloBaseArray';
import { router } from '@/mainjs.js'
import {i18n} from '@/locale/vueI18n'

export class MapLayerAction {
   
  public [types.MAPLAYER_REQUEST](context: ActionContext<IMapLayerState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.MAPLAYER_REQUEST)
        apiAdminMapLayer
          .getMapLayers()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const mapLayerArray = resp.data.data as AloBaseArray<AloDbMapLayer>
              context.commit(types.MAPLAYER_SUCCESS, mapLayerArray.items)
              resolve(mapLayerArray.items)
            } else {
              context.commit(types.MAPLAYER_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.MAPLAYER_ERROR)
            reject()
          })
      })
  }

  public [types.MAPLAYER_ENSURE_LIST](context: ActionContext<IMapLayerState, IRootState>) {
    if(context.state.mapLayers.length == 0) {
        return context.dispatch(types.MAPLAYER_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.mapLayers)            
        })
    }    
  }

  public [types.MAPLAYER_ENSURE_DETAIL](context: ActionContext<IMapLayerState, IRootState>, itemId:number) {
    const mapLayer = context.getters.mapLayersById[itemId] as AloDbMapLayer      
    if(mapLayer && mapLayer.detailLoaded) {   
        return new Promise((resolve, reject) => {            
          resolve(mapLayer)            
      }) 
    }
    else {
      return context.dispatch(types.MAPLAYER_SELECT_DETAIL_REQUEST,itemId)
    }    
  }

  public [types.MAPLAYER_SELECT_DETAIL](context: ActionContext<IMapLayerState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const mapLayer = context.getters.mapLayersById[itemId] as AloDbMapLayer      
      if(mapLayer) {        
        if(mapLayer.detailLoaded) {
          context.commit(types.MAPLAYER_SELECT_DETAIL,mapLayer)
          resolve(mapLayer)
        }
        else{
          context.dispatch(types.MAPLAYER_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
            context.commit(types.MAPLAYER_SELECT_DETAIL,ens)
            resolve(ens)
          })
        }
      }    
      else{
        const newMapLayer = new AloDbMapLayer()
        context.commit(types.MAPLAYER_SELECT_DETAIL,newMapLayer)
        resolve(newMapLayer)
      }
    })
  }

  public [types.MAPLAYER_SELECT_DETAIL_REQUEST](context: ActionContext<IMapLayerState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.MAPLAYER_SELECT_DETAIL_REQUEST, itemId)
        apiAdminMapLayer
          .getMapLayer(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const mapLayer = resp.data.data as AloDbMapLayer
              context.commit(types.MAPLAYER_SELECT_DETAIL_SUCCESS, mapLayer)
              context.commit(types.MAPLAYER_SELECT_DETAIL,mapLayer)
              resolve(mapLayer)
            } else {
              context.commit(types.MAPLAYER_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.MAPLAYER_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.MAPLAYER_SAVE_REQUEST](context: ActionContext<IMapLayerState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmMapLayer.id
        context.commit(types.MAPLAYER_SAVE_REQUEST,context.state.modifiedAdmMapLayer.LAY_LIBELLE)
        apiAdminMapLayer
          .saveMapLayer(context.state.modifiedAdmMapLayer)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const mapLayer = resp.data.data as AloDbMapLayer            
              context.commit(types.MAPLAYER_SELECT_DETAIL_SUCCESS, mapLayer)
              context.commit(types.MAPLAYER_SELECT_DETAIL,mapLayer)               
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:mapLayer.LAY_LIBELLE}))
              if(tryRedirect && router.app.$route.name === 'NewMapLayer') router.push({name:'EditMapLayer',params:{mapLayerid:mapLayer.id!.toString()}})
              resolve(mapLayer)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.MAPLAYER_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))              
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.MAPLAYER_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }

  public [types.MAPLAYER_UPDATE_MODIFIED_ADM](context: ActionContext<IMapLayerState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MAPLAYER_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmMapLayer)
    })
  }
  
  public [types.MAPLAYER_CANCEL_MODIFIED_ADM](context: ActionContext<IMapLayerState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MAPLAYER_SELECT_DETAIL,context.state.originalAdmMapLayer)
      resolve(context.state.modifiedAdmMapLayer)
    })
  }

  public [types.MAPLAYER_UPDATE_FILTER_ADM](context: ActionContext<IMapLayerState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MAPLAYER_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }

  public [types.MAPLAYER_DELETE_REQUEST](context: ActionContext<IMapLayerState, IRootState>,layer:AloDbMapLayer) {
    return new Promise<void>((resolve, reject) => {      
      const layerId = layer?layer.LAY_ID!:context.state.originalAdmMapLayer.LAY_ID!
      const layerLabel = layer?layer.LAY_LIBELLE:context.state.originalAdmMapLayer.LAY_LIBELLE          

      context.commit(types.MAPLAYER_DELETE_REQUEST, layerLabel)
      apiAdminMapLayer
        .deleteMapLayer(layerId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context.commit(types.MAPLAYER_DELETE_SUCCESS, layerId)
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.DeleteOk',{item:layerLabel}))   
            if (router.app.$route.name === 'EditMapLayer' && context.state.originalAdmMapLayer.LAY_ID! == layerId) {
              router.push({ name: 'NewMapLayer' })
            }
            resolve()
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.MAPLAYER_DELETE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.MAPLAYER_DELETE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
            console.error(er)
            reject(er)
          } else {
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }


  public [types.MAPLAYER_SET_GROUP_NAME_REQUEST](context: ActionContext<IMapLayerState, IRootState>, payload:{layerIds:Array<number>,groupName:string}) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MAPLAYER_SET_GROUP_NAME_REQUEST, payload)
      apiAdminMapLayer
        .setGroupName(payload)
        .then(resp => {            
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const mapLayerArray = resp.data.data as AloBaseArray<AloDbMapLayer>
            context.commit(types.MAPLAYER_SET_GROUP_NAME_SUCCESS, mapLayerArray.items)
            resolve(mapLayerArray.items)
          } else {
            context.commit(types.MAPLAYER_SET_GROUP_NAME_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.MAPLAYER_SET_GROUP_NAME_ERROR)
          reject()
        })
    })
  }

  
  
}

export default util.classToObject(MapLayerAction)